import { Component, computed, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BuildingEquipmentFilterDto,
  BuildingEquipmentItemDto,
  BuildingEquipmentService,
  BuildingService,
  EquipmentItemDto,
  EquipmentService,
  TenantDetailDto
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BuildingDetailDto } from '@artemis-software/wr-api/model/buildingDetailDto';
import { currentTenantId } from '@/utils/admin-utils';
import { DataTableComponent } from '@shared/generic/data-table/data-table.component';
import { CurrentUserService } from '@services/current-user.service';
import { map } from 'rxjs';

@Component({
  standalone: false,
  selector: 'wr-external-tga-type-overview-page',
  templateUrl: './external-tga-overview-page.component.html',
  styleUrls: ['./external-tga-overview-page.component.scss'],
})
export class ExternalTgaOverviewPageComponent {
  @ViewChild(DataTableComponent) dataTable!: DataTableComponent<BuildingEquipmentItemDto, BuildingEquipmentFilterDto>;
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateTgas'));
  form!: FormGroup;

  currentTenantId = currentTenantId();

  readonly loadBuildingEquipments = (filter: BuildingEquipmentFilterDto) => this.buildingEquipmentService.findAll({ ...filter, ownerTenantId: this.currentTenantId() });
  readonly getCount = (filter: BuildingEquipmentFilterDto) => this.buildingEquipmentService.getCount({ ...filter, ownerTenantId: this.currentTenantId() });

  constructor(private readonly router: Router,
              private readonly activeRoute: ActivatedRoute,
              private readonly formBuilder: FormBuilder,
              private readonly buildingEquipmentService: BuildingEquipmentService,
              private readonly buildingService: BuildingService,
              private readonly currentUserService: CurrentUserService,
              private readonly equipmentService: EquipmentService) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      creatorTenantId: this.formBuilder.control<string | null>(null),
      equipmentId: this.formBuilder.control<string | null>(null),
      equipment: this.formBuilder.control(undefined),
      buildingId: this.formBuilder.control<string | null>(null),
      building: this.formBuilder.control(undefined),
      facilityElement: this.formBuilder.control<string | null>(null),
      customFieldFilters: this.formBuilder.control(undefined),
    });

    this.form.get('creatorTenantId')?.valueChanges.subscribe(() => {
      this.form.get('equipment')?.setValue(undefined);
    });

    this.form.get('equipment')?.valueChanges.subscribe((equipment: EquipmentItemDto) => {
      this.form.get('equipmentId')?.setValue(equipment?.id);
      this.form.get('customFieldFilters')?.setValue(undefined);
    });

    this.form.get('customFieldFilters')?.valueChanges.subscribe(() => {
      this.dataTable?.applyFormValueToFilter();
    });

    this.form.get('building')?.valueChanges.subscribe((building: BuildingDetailDto) => {
      this.form.get('buildingId')?.setValue(building?.id);
    });

    this.activeRoute.queryParams.subscribe((params) => {
      if (params['buildingId']) {
        this.buildingService.findById(params['buildingId']).subscribe((building) => {
          this.form.get('building')?.setValue(building);
          this.dataTable.applyFormValueToFilter();
        });
      }

      if (params['equipmentId']) {
        this.equipmentService.findByIds([params['equipmentId']])
          .pipe(map((array) => array[0]))
          .subscribe((equipment) => {
            this.form.get('equipment')?.setValue(equipment);
            this.dataTable.applyFormValueToFilter();
          });
      }
    });
  }

  navigateToBuildingEquipment(buildingEquipment: BuildingEquipmentItemDto): void {
    this.router.navigate(['buildingEquipment', buildingEquipment.id]);
  }

  add(): void {
    this.router.navigate(['buildingEquipment', 'new']);
  }

  protected readonly TenantTypeEnum = TenantDetailDto.TypeEnum;
}
